const roadblockMessageName = 'mobile_roadblock';

// From coffeescript version on window
const checkLinkAndAppendLanguage = link => {
  const containsLangFolder = /^\/(es|fr|de)(($)|(\/.*))$/;
  if (typeof window !== 'undefined' && window.location && window.location.pathname.match(containsLangFolder)) {
    if (window.location.pathname.match(/^\/fr(($)|(\/.*))$/) && !link.match(/^\/fr(($)|(\/.*))$/)) {
      return `/fr${link}`;
    }
    if (window.location.pathname.match(/^\/es(($)|(\/.*))$/) && !link.match(/^\/es(($)|(\/.*))$/)) {
      return `/es${link}`;
    }
    if (window.location.pathname.match(/^\/de(($)|(\/.*))$/) && !link.match(/^\/de(($)|(\/.*))$/)) {
      return `/de${link}`;
    }
  }
  return link;
};

const onRoadblockedClick = (messagingChannel, event, currentUser, afterRoadblock, options) => {
  const returnToUrl = options && options.returnToUrl ? options.returnToUrl : window.location.pathname + window.location.search;
  const atRef = options && options.atRef ? options.atRef : undefined;
  const openInNewTab = !!(options && options.openInNewTab);

  messagingChannel.publish(roadblockMessageName, {
    event,
    currentUser,
    atRef,
    afterRoadblock,
    returnToUrl,
    openInNewTab
  });
};

const buildSignupUrl = (href, atRef) => {
  const ref = atRef ? `ref=${atRef}&` : '';
  const returnTo = `returnTo=${encodeURIComponent(href)}`;
  return checkLinkAndAppendLanguage(`/signup?${ref}${returnTo}`);
};

const buildNonRoadblockedUrl = (href, atRef) => {
  const ref = atRef ? `${href.indexOf('?') === -1 ? '?' : '&'}ref=${atRef}` : '';
  return checkLinkAndAppendLanguage(`${href}${ref}`);
};

export { roadblockMessageName, onRoadblockedClick, buildSignupUrl, buildNonRoadblockedUrl };
